if (!customElements.get('slider-wrapper')) {
  class SliderWrapper extends HTMLElement {
    constructor() {
      super();
      this.breakpointMobile = 767;
    }

    calculateSliderOptionsIndex() {
      return window.innerWidth > this.breakpointMobile ? 0 : 1;
    }

    getCurrentOptions(){
      return this.sliderOptions[this.sliderOptionsIndex];
    }

    getOptionSets(){
      return this.sliderOptions;
    }

    processSliderOptions() {
      // clean out any empty data points
      this.sliderOptions.forEach(optionSet => {
        for (const property in optionSet) {
          if (optionSet[property] === '' || optionSet[property] === null) {
            delete optionSet[property];
          }
        }
      });
      // scrub the DOM of any settings data
      delete this.dataset.desktopSettings;
      delete this.dataset.mobileSettings;
    }

    initSlider(isResize) {
      // grab the current optsion set
      const currentOptions = this.sliderOptions[this.sliderOptionsIndex];
      // if the slider is already initialized and we are not resizing, exit
      if (this.classList.contains('is-initialized') && !isResize) return;
      // if we want this set disabled, exit
      if (!currentOptions.enabled) {
        if(this.slider){
          this.slider.destroy();
        }
        return;
      }
      // if we are resizing, destroy the slider instance
      if (isResize && this.slider) this.slider.destroy();
      // reinit the slider with a new flickity instance with the latest dataset
      this.slider = new Flickity(this, currentOptions);
      this.classList.add('is-initialized');

      // when the slider is settled, clean it up a little bit.
      this.slider.on('settle', () => {
        this.slider.reloadCells();
        this.slider.resize();

        if (this.hasAttribute('check-height')) {
          const viewport = this.querySelector('.flickity-viewport');
          const selected = this.querySelector('.is-selected');
          viewport.style.height = `${selected.offsetHeight}px`;
          window.dispatchEvent(new Event('resize'));
          this.slider.resize();
        }
      });
    }

    initResizeEvent() {
      window.addEventListener('resize', () => {
        const newIndex = this.calculateSliderOptionsIndex();
        // if we have a new index aka options set, re-init the slider
        if (this.sliderOptionsIndex !== newIndex) {
          this.sliderOptionsIndex = newIndex;
          this.initSlider(true);
        }
        // if we are on mobile size, adjust the height of the slider.
        if (window.innerWidth < this.breakpointMobile) {
          this.style.height = 'auto';
        }
      });
    }

    initSliderButtons() {
      const currentOptions = this.sliderOptions[this.sliderOptionsIndex];
      const targetSlider = document.querySelector(currentOptions.asNavFor);
      if (!targetSlider) return;

      const prev = this.querySelector('.flickity-prev-next-button.previous');
      const next = this.querySelector('.flickity-prev-next-button.next');

      prev.addEventListener('click', () => targetSlider.slider.previous());
      next.addEventListener('click', () => targetSlider.slider.next());
    }

    initWheelEvent() {
      // Wheel event listener to navigate the slider
      this.addEventListener('wheel', (event) => {
        if(!window.Flickity) return;

        const flkty = Flickity.data(this);
        if (!flkty) return;

        const isHorizontalScroll = Math.abs(event.deltaX) > Math.abs(event.deltaY);

        if(!isHorizontalScroll) return;

        event.preventDefault();
        if (event.deltaX > 0 || event.deltaY > 0) {
          flkty.next();
        } else if (event.deltaX < 0 || event.deltaY < 0) {
          flkty.previous();
        }
      });
    }

    connectedCallback() {
      // if the component is disabled or flickity is not available, cancel the component.
      if (this.hasAttribute('disabled') || !window.Flickity) return;
      // set up default values and option data
      this.sliderOptionsDesktop = JSON.parse(this.dataset.desktopSettings) || {};
      this.sliderOptionsMobile = JSON.parse(this.dataset.mobileSettings) || {};
      this.sliderOptions = [this.sliderOptionsDesktop, this.sliderOptionsMobile];
      this.sliderOptionsIndex = this.calculateSliderOptionsIndex();
      // process the options, init the slider, establish events
      this.processSliderOptions();
      this.initSlider(false);
      this.initResizeEvent();
      this.initWheelEvent();
      // extra events if we are dealing with a navigation slider
      if (this.getAttribute('type') === 'nav') {
        this.initSliderButtons();
      }
    }
  }

  customElements.define('slider-wrapper', SliderWrapper);
}

